import { ApiService, QRAuthTokenPOST } from "pwapi";

import { QRAuthTokenPATCH } from "pwapi/models/QRAuthTokenPATCH";

import {
  AsyncSagaAction,
  AsyncSagaActionNoArgs,
  createAsyncSaga,
} from "shared/utils/asyncActions";

export const GET_BARCODE_BADGES_REQUEST = "@@manage/GET_BARCODE_BADGES_REQUEST";
export const GET_BARCODE_BADGES_SUCCESS = "@@manage/GET_BARCODE_BADGES_SUCCESS";
export const GET_BARCODE_BADGES_FAILURE = "@@manage/GET_BARCODE_BADGES_FAILURE";

export const POST_BARCODE_BADGE_REQUEST = "@@manage/POST_BARCODE_BADGE_REQUEST";
export const POST_BARCODE_BADGE_SUCCESS = "@@manage/POST_BARCODE_BADGE_SUCCESS";
export const POST_BARCODE_BADGE_FAILURE = "@@manage/POST_BARCODE_BADGE_FAILURE";

export const PATCH_BARCODE_BADGE_REQUEST =
  "@@manage/PATCH_BARCODE_BADGE_REQUEST";
export const PATCH_BARCODE_BADGE_SUCCESS =
  "@@manage/PATCH_BARCODE_BADGE_SUCCESS";
export const PATCH_BARCODE_BADGE_FAILURE =
  "@@manage/PATCH_BARCODE_BADGE_FAILURE";

export const fetchBarcodeBadges = createAsyncSaga(
  GET_BARCODE_BADGES_REQUEST,
  GET_BARCODE_BADGES_SUCCESS,
  GET_BARCODE_BADGES_FAILURE,
  () => "listQrAuthTokens",
  () => ApiService.listQrAuthTokens({ limit: 99999 })
) as AsyncSagaActionNoArgs;

export const createBarcodeBadge: AsyncSagaAction<{
  requestBody: QRAuthTokenPOST;
}> = createAsyncSaga(
  POST_BARCODE_BADGE_REQUEST,
  POST_BARCODE_BADGE_SUCCESS,
  POST_BARCODE_BADGE_FAILURE,
  (requestBody: QRAuthTokenPOST) =>
    `/api/qr-auth/${requestBody.user_id}/${requestBody.lab_id}/${requestBody.pin}`,
  (requestBody: QRAuthTokenPOST) =>
    ApiService.createQrAuthToken({ requestBody })
);

type UpdateBarcodeBadgeArgs = {
  id: number;
  requestBody: Partial<QRAuthTokenPOST>;
};
export const updateBarcodeBadge: AsyncSagaAction<UpdateBarcodeBadgeArgs> =
  createAsyncSaga(
    PATCH_BARCODE_BADGE_REQUEST,
    PATCH_BARCODE_BADGE_SUCCESS,
    PATCH_BARCODE_BADGE_FAILURE,
    (args: UpdateBarcodeBadgeArgs) => `/api/qr-auth/${args.id}`,
    (args: UpdateBarcodeBadgeArgs) =>
      ApiService.partialUpdateQrAuthToken({
        id: args.id,
        requestBody: args.requestBody as QRAuthTokenPATCH, // TODO: user is not nullable, but we dont' want it in the PATCH
      })
  );
